import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { Icon } from "../../../lib/Icon";
import { tipAttrs } from "../../../lib/tooltip";
import type { ComponentProps } from "react";
import { TerrainLegendBody, TileInfoBody } from "../../../lib/encounter/CombatWindows";
import type { EscLayers } from "../../../lib/encounter/escLayers";
import { useEscEntry } from "../../../lib/encounter/escLayers";

/**
 * **The Map key** (`decisions/0191` Ruling 3, `board-tool-rail` 4.2): one docked panel at the stage's
 * bottom right, left of the tool rail, replacing the LEGEND and TILE windows. The hovered tile sits on
 * top and the marks this map uses below. It rehosts `TileInfoBody` and `TerrainLegendBody` unchanged.
 * Toggled with K (the rail's VIEW section), off by default, and a layer-5 Esc entry (`decisions/0189`), like
 * a window. Not draggable: its place is fixed so it never wanders over the board.
 */
export function MapKeyPanel({
  esc,
  onClose,
  tile,
  legend,
}: {
  esc: EscLayers;
  onClose: () => void;
  tile: ComponentProps<typeof TileInfoBody>;
  legend: ComponentProps<typeof TerrainLegendBody>;
}) {
  useEscEntry(esc, { layer: "window", id: "map-key", active: true, onDismiss: onClose });
  return (
    <aside className="combat-map-key" aria-label="map key">
      <header className="combat-map-key-head">
        <span>MAP KEY</span>
        <button type="button" className="combat-map-key-close" aria-label="Close map key" {...tipAttrs({ label: "Close map key", key: "K or Esc" })} onClick={onClose}>
          <Icon icon={faXmark} />
        </button>
      </header>
      <div className="combat-map-key-body">
        <section className="combat-map-key-tile" aria-label="hovered tile">
          <TileInfoBody {...tile} />
        </section>
        <section className="combat-map-key-legend" aria-label="marks on this map">
          <TerrainLegendBody {...legend} />
        </section>
      </div>
    </aside>
  );
}
